export default __webpack_public_path__ + "static/media/logo_blue.5b3736fa.webp";